import React from "react";
import { Translate, I18n } from "react-redux-i18n";
import { Dialog } from "@blueprintjs/core";
import CustomIcon from "../../components/CustomIcon";
import "./CirclePrintGiftCard.scss";
import PrintModalContent from "./PrintModalContent";
class CirclePrintGiftCard extends React.Component {
  state = {
    show_modal: false,
  };

  showModal = () => {
    this.setState({ show_modal: true });
  };

  closeModal = () => {
    this.setState({ show_modal: false });
  };

  print = (e) => {
    e.preventDefault();
    window.print();
  };

  render() {
    const { show_modal } = this.state;
    const { circle } = this.props;
    const circle_url = `https://app.ihopa.com/circle/${circle.guid}?product_tour_id=83573`;

    return (
      <>
        <div className="custom-card circle-gift-card print" onClick={this.showModal}>
          <CustomIcon name="print" className="icon" size="48" />
          <div className="gift-card-copy">
            <h1>
              <Translate value="whitemonday.print_gift_card.header" />
            </h1>
            <div className="copy-details">
              <Translate value="whitemonday.print_gift_card.subheading" />
            </div>
          </div>
        </div>
        <Dialog
          title={I18n.t("whitemonday.print_gift_card.title")}
          autoFocus={true}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          enforceFocus={true}
          isOpen={show_modal}
          onClose={this.closeModal}
          usePortal={true}>
          <PrintModalContent circle={circle} circleUrl={circle_url} />
        </Dialog>
      </>
    );
  }
}

export default CirclePrintGiftCard;
